module.exports = __webpack_public_path__ + "img/shrimp-casserole.ebfe2ebe.jpg";